import { schema } from "normalizr";

const locationSchema = new schema.Entity("location", {}, { idAttribute: "id" });

export { locationSchema };
